import Typography from '@mui/material/Typography';
import { Box } from '@mui/system';
import { sortOptions } from 'common/types/sort-params';
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { cacheSelectors } from 'redux/cache.slice';
import { RootState } from 'redux/root-reducer';
import { searchParamActions, searchParamSelectors } from 'redux/search-param.slice';
import { WsNativeSelect } from 'stories/inputs/WsNativeSelect';
import WsFlexbox from 'stories/layout/WsFlexbox';

const SortRange = () => {
  const dispatch = useDispatch();
  const sortIdx = useSelector((state: RootState) => searchParamSelectors.sortIdx(state));

  return (
    <WsFlexbox
      padding={0}
      right
      gap={2}
      sx={{
        alignItems: 'flex-start',
        marginTop: 1,
      }}
    >
      <Typography variant="subtitle2">Sort By:</Typography>
      <WsNativeSelect
        width={150}
        id="sortRange"
        data={sortOptions}
        value={sortIdx.toString()}
        onChange={(event: React.ChangeEvent<HTMLSelectElement>) =>
          dispatch(searchParamActions.sortIdx(event.target.value))
        }
        sx={{ position: 'relative', top: '-5px' }}
        fsx={{ minHeight: 0 }}
      />
    </WsFlexbox>
  );
};

export default SortRange;
